<template>
  <v-snackbar
    class="snackbar"
    v-model="showSnackbar"
    :timeout="timeout"
    :color="color"
    top
  >
    {{ text }}
    <template v-slot:action="{ attrs }">
      <v-btn
        color="white"
        text
        v-bind="attrs"
        @click="close"
      >
        <v-icon>close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'snack',
  data () {
    return {
      text: '',
      showSnackbar: false,
      color: 'success',
      timeout: 3000
    }
  },
  methods: {
    show (data) {
      this.text = data.text
      if (data.error) this.color = 'error'
      else this.color = 'success'
      if (data.timeout) this.timeout = data.timeout
      this.showSnackbar = true
    },
    close () {
      this.showSnackbar = false
    }
  }
}
</script>


// WEBPACK FOOTER //
// GlobalSnackbar.vue?0de7324b